module.exports = __webpack_public_path__ + "assets/normal/images/shareLogo.39181915.png";